import axiosInstance from './../axiosInstance';
import { buildParams } from './../buildParams';

/**
 * @name getProducts
 * @desc Get event products.
 * @param {string} eventID
 * @param {object} filters
 */
export const getProducts = (eventID, filters) => {
	return axiosInstance.get(`events/${eventID}/products`, { params: filters });
};

export const getProductsWithParams = (eventID, params = {}) => {
	return axiosInstance.get(`events/${eventID}/activeProducts`, { params: buildParams(params) });
};

/**
 * @name getProduct
 * @desc Get product.
 * @param {string} productID
 */
export const getProduct = (productID) => {
	return axiosInstance.get(`products/${productID}`);
};

/**
 * @name getProductBundles
 * @desc Get product bundles.
 */
export const getProductBundles = () => {
	return axiosInstance.get('/productBundles');
};

/**
 * @name getProductCategories
 * @desc Get event product categories.
 * @param {string} eventID
 */
export const getProductCategories = (eventID) => {
	return axiosInstance.get(`events/${eventID}/productCategories`);
};

/**
 * @name getOrders
 * @desc Get orders.
 * @param {string} eventID
 */
export const getOrders = (eventID, params = {}) => {
	const partnerID = localStorage.getItem('partnerID');
	const orderParams = {
		...params,
		filters: {
			'filter[1][column]': 'partnerID',
			'filter[1][condition]': 'in',
			'filter[1][values][0]': partnerID
		}
	};

	let url = eventID ? `events/${eventID}/orders` : 'orders'
	return axiosInstance.get(url, { params: buildParams(orderParams) });
};

// for react-table, different kind of params handling
export const getOrdersForDataTable = (eventID, params = {}) => {
	let url = eventID ? `events/${eventID}/orders` : 'orders'
	return axiosInstance.get(url, { params });
};

/**
 * @name getOrder
 * @desc Get order.
 * @param {string} orderID
 */
export const getOrder = (orderID, eventID) => {
	const url = (!eventID) ? 'orders/' + orderID : 'events/' + eventID + '/orders/' + orderID;
	return axiosInstance.get(url);
};

/**
 * @name updateOrder
 * @desc Get order.
 * @param {string} orderID
 */
export const updateOrder = (orderID, order, eventID) => {
	let url = '/events/' + eventID + '/orders/createForPartner';
	if (orderID && orderID !== null) {
		url = '/orders/' + orderID;
	}
	return axiosInstance.post(url, order);
};

/**
 * @name getOrder
 * @desc Get order.
 */
export const getOrderRowsMeta = () => {
	const url = '/orderRows/meta';
	return axiosInstance.get(url);
};

/**
 * @name getOrdersMeta
 * @desc Get order.
 */
export const getOrdersMeta = () => {
	const url = '/orders/meta';
	return axiosInstance.get(url);
};

/**
 * @name getTickets
 * @param {string} eventID
 * @param {string} partnerID
 * @param {object} params 
 */
export const getTickets = (eventID, partnerID, params) => {
	let url = `events/${eventID}/partners/${partnerID}/tickets`;
	return axiosInstance.get(url, { params: buildParams(params) });
};

/**
 * @name sendTicket
 * @param {string} ticketID
 * @param {object} recipient 
 */
export const sendTicket = (ticketID, recipient) => {
	let url = `tickets/${ticketID}/send`;
	return axiosInstance.post(url, recipient);
};
